import { Provider } from "react-redux";
import ShortsData from "../../data/shorts.json";
import PageHead from "../Head";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import Banner from "@/components/Common/Banner";
// import BlogGrid from "@/components/Blogs/BlogGrid";
import ShortsSeasons from "@/components/Shorts/ShortsSeasons";
import BackToTop from "../backToTop";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
// import BlogGridMinimal from "@/components/Blogs/BlogGridMinimal";
import Instagram from "@/components/Instagram/Instagram";

const BlogGridLayout = () => {
  let shortsData = JSON.parse(JSON.stringify(ShortsData.seasonList));
  let seasonList = shortsData.sort((a, b) => a.season - b.season);

  return (
    <>
      <PageHead title="Learn Cloud Computing through Shorts" description="Shorts series prepared by CloudPedia authors" />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <Cart />

          <Banner col="col-lg-12" text="Shorts - Seasons" getBlog={seasonList} listType="Seasons" />
          <div className="rbt-blog-area rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="container">
              {/* <BlogGridMinimal start={0} end={3} isPagination={false} /> */}
              <ShortsSeasons blogType="short" course={seasonList} isPagination={true} top={true} start={0} end={10} />
            </div>
          </div>

          <Instagram />
          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default BlogGridLayout;
